<template>
  <div>
    <nav
      id="main-header"
      class="
        navbar navbar-expand-md
        fixed-top
        navbar-dark
        justify-content-between
        flex-nowrap
      "
      :class="{
        'shadow-half': headerBackground,
        mobileActive: navbarMobileVisible,
        headerBackground: headerBackground,
      }"
      :style="[$route.name != 'jobs' ? {} : {}]"
    >
      <div class="container">
        <button
          class="
            hamburger hamburger--slider
            navbar-toggle
            mr-3
            d-lg-none d-xm-block
          "
          :class="{ 'is-active': navbarMobileVisible }"
          type="button"
          @click="toggleMenu"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>

        <router-link to="/" class="navbar-brand m-0 mr-auto">
          <img
            src="@/assets/images/gusmao-labrunie/logo-gusmao-labrunie.png"
            alt="gusmao-labrunie"
            class="logo-white logo"
          />
          <img
            src="@/assets/images/gusmao-labrunie/logo-gusmao-labrunie.png"
            alt="gusmao-labrunie Logotipo"
            class="logo-blue logo"
          />
        </router-link>

        <div class="d-flex">
          <ul class="navbar-nav navbar-mobile">
            <span class="navbar-mobile-bg" @click="toggleMenu"></span>

            <div
              class="d-flex flex-column d-lg-none border-bottom"
              v-if="this.$store.state.user.profile"
            >
              <li class="nav-item">
                <div class="nav-link">
                  <h5 class="m-0 text-primary">
                    Olá{{ firstName && ", " + firstName }}!
                  </h5>
                </div>
              </li>

              <li class="nav-item" @click="toggleMenu">
                <router-link to="/meu-perfil" class="nav-link"
                  >Meu Perfil</router-link
                >
              </li>
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  @click="changeModal('change-password')"
                  >Alterar Senha</a
                >
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" @click="signOut">Sair</a>
              </li>
            </div>
            <li class="nav-item" @click="toggleMenu">
              <router-link to="/#quem-somos" class="nav-link"
                >QUEM SOMOS</router-link
              >
            </li>
            <li class="nav-item" @click="toggleMenu">
              <router-link to="/vagas" class="nav-link">VAGAS</router-link>
            </li>
            <!-- <li class="nav-item" @click="toggleMenu">
            <router-link to="/vagas" class="nav-link">vagas</router-link>
          </li> -->
            <li class="nav-item" @click="toggleMenu">
              <router-link to="/#faq" class="nav-link">FAQ</router-link>
            </li>
            <li
              class="nav-item"
              @click="toggleMenu"
              v-if="!$store.state.user.isAuth || !$store.state.user.follower"
            >
              <router-link to="/deixe-seu-perfil" class="nav-link register"
                >Cadastre seu currículo</router-link
              >
            </li>
            <li
              class="nav-item text-white"
              v-if="$store.state.user.isAuth && !$store.state.user.follower"
            >
            </li>

            <li
              class="nav-item d-none d-lg-flex"
              @click="toggleMenu"
              v-if="this.$store.state.user.isAuth"
            >
              <b-dropdown
                size="xl"
                text="Acesse seu Perfil"
                class="nav-link"
                no-caret
                right
              >
                <b-dropdown-header
                  >Olá{{ firstName && ", " + firstName }}!</b-dropdown-header
                >
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item to="/meu-perfil">Meu Perfil</b-dropdown-item>
                <b-dropdown-item @click="changeModal('change-password')"
                  >Alterar Senha</b-dropdown-item
                >
                <b-dropdown-item @click="signOut">Sair</b-dropdown-item>
              </b-dropdown>
            </li>
          </ul>
          <!-- 
        <ul class="navbar-nav d-flex flex-row d-lg-none">
          <li class="nav-item">
            <router-link to="/vagas" class="nav-link text-center">
              <magnify-icon class="h5 mb-0 align-middle" />
            </router-link>
          </li>
        </ul> -->
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";

export default {
  name: "MainHeader",

  data() {
    return {
      headerBackground: false,
      navbarMobileVisible: false,
      heroSection: null,
    };
  },

  computed: {
    firstName() {
      if(this.$store.state.user){
        const profile = this.$store.state.user.profile;
        const socialName = profile.socialName;
        const name = profile.name.split(' ')[0];
        if(socialName){
          return socialName;
        } else if(window.signUp){
          return null
        } else if(name){
          return name;
        }
      }

      return null;
    },
  },

  components: {
    MagnifyIcon,
  },

  methods: {
    handleScroll(event) {
      let scrolledAfter = this.heroSection
        ? this.heroSection.offsetHeight - 80
        : -1;
      let scrollY = window.scrollY || window.pageYOffset;

      if (scrollY > 100) {
        this.headerBackground = true;
      } else {
        this.headerBackground = false;
      }
    },

    toggleMenu() {
      this.navbarMobileVisible = !this.navbarMobileVisible;
      const intercomBtn = document.querySelector(".intercom-launcher-frame");
      if (intercomBtn) {
        if (this.navbarMobileVisible) {
          intercomBtn.classList.add("show");
        } else {
          intercomBtn.classList.remove("show");
        }
      }
    },

    signOut() {
      this.$store.dispatch("user/signOut");
      if (this.$route.meta.requiresAuth) this.$router.push("/");
    },

    changeModal(target) {
      this.$store.commit("DEVISE_FORM", target);
    },
  },

  mounted() {
    this.heroSection = document.querySelector(".hero");
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    $route(to, from) {
      this.heroSection = document.querySelector(".hero");
      this.handleScroll();
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  transition: all 0.3s ease-out;
  padding: 1rem 0px 1rem 0px;
  background-color: #303336;
  .full-color {
    position: absolute;
    top: -4px;
    left: 0;
  }

  @include media-breakpoint-down(sm) {
    padding: 0px 1rem;
    height: 50px;
  }

  &.headerBackground {
    padding: 0.5rem 0px;
    .navbar-brand img.logo-blue {
      display: none;
    }
    .navbar-brand:before {
      display: none;
    }
    .navbar-brand img.logo-white {
      display: block;
    }
    @include media-breakpoint-down(sm) {
      padding: 0px 1rem;
      height: 50px;
    }
  }

  .navbar-brand {
    width: 250px;

    position: relative;

    img {
      display: block;

      &.logo-white {
        display: none;
      }
      @include media-breakpoint-down(sm) {
        max-width: 150px;
        margin: 0 auto;
      }
    }
  }

  .nav-item {
    display: flex;
    align-items: center;

    .nav-link {
      font-size: 1.1rem;
      color: #fff;
      width: 100%;
      padding-left: 5rem;
      font-family: "Proxima Nova Lt";
      background-color: transparent !important;
      &:hover {
        opacity: 0.7;
      }

      @include media-breakpoint-up(lg) {
        text-align: center;
      }

      &.register {
        background: #efeae0 0% 0% no-repeat padding-box !important;
        border-radius: 9px;
        padding-left: 0px;
        margin-left: 4rem;
        color: #212224;
        font-weight: bold;
        padding: 0.3rem 1.3rem !important;
      }
    }

    &:last-of-type {
      .nav-link {
        padding-right: 0;
      }
    }
  }

  &.mobileActive {
    .navbar-mobile {
      transform: translateX(0vw);

      .navbar-mobile-bg {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .navbar-mobile {
    .navbar-mobile-bg {
      display: none;
    }

    @include media-breakpoint-down(md) {
      width: 290px;
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      background: #fff;
      z-index: 10;
      transform: translateX(-100vw);
      transition: transform 0.3s ease-in-out;
      flex-direction: column !important;

      .nav-item {
        width: 100%;

        &.active {
          .nav-link {
            background-color: theme-color("light-dark") !important;
            border-bottom: none !important;
          }
        }

        .nav-link {
          color: $body-color !important;
          padding: 1rem !important;
          font-weight: 400 !important;
          text-transform: capitalize !important;
          &:hover {
            background-color: theme-color("light-dark") !important;
          }
        }
      }

      .navbar-mobile-bg {
        display: block;
        width: 200vw;
        height: 100%;
        position: fixed;
        left: 290px;
        right: 0;
        background: #303336;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease-in-out 0.1s, visibility 0.01s linear;
      }
    }
  }
}
</style>
